import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaymentService } from '../../../../../services/payment.service';
import { CardModel } from '../../../../../../shared/models/payment/card.model';
import { PaymentMethodModel } from '../../../../../../shared/models/payment-method.model';

@Component({
    'selector': 'payment-payment-option-card-item',
    'templateUrl': './payment.payment.option.card.item.component.html',
    'styleUrls': ['../../../../../payment.component.scss']
})
export class PaymentPaymentOptionCardItemComponent {
    @Input() cardIndex: number;
    @Input() index: number;
    @Input() card: CardModel;
    @Input() paymentMethod: PaymentMethodModel;
    @Input() cardsCount: Array<number>;
    @Output() filled: EventEmitter<CardModel> = new EventEmitter();

    constructor(
        protected paymentService: PaymentService
    ) {}

    public onChange() {
        if (this.paymentMethod.allow_multiple_cards && this.cardsCount && this.cardsCount.length > 1) {
            this.paymentService.pushCard(this.cardIndex, this.card);
            this.filled.emit(this.card);
            return;
        }

        this.paymentService.setCard(this.card);
        this.filled.emit(this.card);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/payment/payment/option/card/option/item/payment.payment.option.card.item.component.ts